import { render, staticRenderFns } from "./detailKaryawan.vue?vue&type=template&id=a26fe5f6"
import script from "./detailKaryawan.vue?vue&type=script&lang=js"
export * from "./detailKaryawan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports